import { ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { FormOfTeaching } from "../../models/FormOfTeaching";
import { CreateFormOfTeachingRequest } from "./CreateFormOfTeachingRequest";
import { EditFormOfTeachingRequest } from "./EditFormOfTeachingRequest";
import { SearchFormOfTeachingRequest } from "./SearchFormOfTeachingRequest";

const formOfTeachingUrlPrefix: string = "forms-of-teaching";
export const searchFormsOfTeaching = async (request: SearchFormOfTeachingRequest) => {
  let result = await api.get(
      `${formOfTeachingUrlPrefix}/search`,
      request
  ) as PagedResult<FormOfTeaching>;
  setDatesFormsOfTeaching(result.results);
  return result;
}

export const getFormOfTeachingById = async (id: number) => {
  let result = await api.get(
      `${formOfTeachingUrlPrefix}/${id}`
  ) as FormOfTeaching;
  setDatesFormOfTeaching(result);
  return result
}

export const createFormOfTeaching = async (request: CreateFormOfTeachingRequest) => {
  return api.post(
      `${formOfTeachingUrlPrefix}`,
      request
  ) as Promise<number>
}

export const editFormOfTeaching = async (id: number, request: EditFormOfTeachingRequest) => {
  return api.put(
      `${formOfTeachingUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const deleteFormOfTeaching = async (id: number) => {
  return api.delete(
      `${formOfTeachingUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportFormsOfTeachings = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${formOfTeachingUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

const setDatesFormsOfTeaching = (items: FormOfTeaching[]) => {
  for (let item of items) {
    setDatesFormOfTeaching(item);
  }
}

const setDatesFormOfTeaching = (item: FormOfTeaching) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}